import request from '@/utils/request'

const userApi = {
  queryProfile: () => {
    return request({
      url: '/client/info',
      method: 'get'
    })
  },
  updateProfile: (data) => {
    return request({
      url: '/client/update',
      method: 'post',
      data
    })
  },
  updatePassword: (data) => {
    return request({
      url: '/client/update-password',
      method: 'post',
      data
    })
  },
  queryAdddressList: () => {
    return request({
      url: '/client/address/list',
      method: 'get'
    })
  },
  addAddress: (data) => {
    return request({
      url: '/client/address/add',
      method: 'post',
      data
    })
  },
  updateAddress: (data) => {
    return request({
      url: '/client/address/update',
      method: 'post',
      data
    })
  },
  removeAddress: (data) => {
    return request({
      url: '/client/address/remove',
      method: 'post',
      data
    })
  },
  checkSfaCode: (data) => {
    return request({
      url: '/client/sfa/check-code',
      method: 'post',
      data
    })
  },
  queryInvoiceList: () => {
    return request({
      url: '/client/invoice/list',
      method: 'get'
    })
  },
  addInvoice: (data) => {
    return request({
      url: '/client/invoice/add',
      method: 'post',
      data
    })
  },
  updateInvoice: (data) => {
    return request({
      url: '/client/invoice/update',
      method: 'post',
      data
    })
  },
  removeInvoice: (data) => {
    return request({
      url: '/client/invoice/remove',
      method: 'post',
      data
    })
  },
  queryDistributeList: (params) => {
    return request({
      url: '/coupon/group/list',
      method: 'get',
      params
    })
  },
  getCouponInfo: (params) => {
    return request({
      url: '/coupon/group/info',
      method: 'get',
      params
    })
  },
  assingCoupin: (data) => {
    return request({
      url: '/coupon/assign',
      method: 'post',
      data
    })
  },
  querySubClient: (params) => {
    return request({
      url: '/client/allot/query/sub',
      method: 'get',
      params
    })
  },
  queryAssignRecord: (params) => {
    return request({
      url: '/coupon/assign/record',
      method: 'get',
      params
    })
  },
  queryDistributeHistoryList: (params) => {
    return request({
      url: '/coupon/all/assign/record',
      method: 'get',
      params
    })
  },
  backCoupin: (data) => {
    return request({
      url: '/coupon/assign/back',
      method: 'post',
      data
    })
  },
  getReturnCouponInfo: (query) => {
    return request({
      url: '/coupon/define/info/' + query,
      method: 'get'
    })
  }
}
export default userApi
